const prefix = 'league';

export const createLeague = `${prefix}`;
export const updateLeague = (leagueId: string) => `${prefix}/${leagueId}`;

export const getLeagues = `${prefix}`;

export const getLeagueDetail = (leagueId: string) => `${prefix}/${leagueId}`;
